// We are using an asset from the existing project structure.
import reportBook from "../assets/images/love-report/report-book.jpg";

export const pricingPlans = [
  {
    id: "love-report",
    badge: "FLAT 50% OFF",
    title: "Love Report",
    subtitle: '',
    priceOriginal: "₹999",
    priceFinal: "₹599",
    image: reportBook,
    features: [
      "Deep analysis of your emotional energy, attraction patterns, and how you express love.",
      "Insight into your Venus and Mars placement and their influence on romance.",
      "Reasons for past heartbreaks, repeated patterns, or emotional detachment.",
      "Written in clear, easy-to-understand language by expert astrologers."
    ],
    description: "",
    isBestSeller: false,
    // Add prices for the add-ons here
    astroConsultationPrice: 2100,
    expressDeliveryPrice: 149,
  },
  {
    id: "love-report-consultation",
    badge: "BEST SELLER",
    title: "Love Report + 1-On-1 Consultation",
    subtitle: "",
    priceOriginal: "₹2999",
    priceFinal: "₹1599",
    image: reportBook,
    features: [
        "Includes everything that’s part of the detailed Love Report — from energy analysis to compatibility.",
        "15-20 minutes private session with an expert Astrologer within 3 days.",
        "Get a Real Time clearity on your relationship questions.",
        "Get personalized, tailored remedies and guidance designed specifically for you."
    ],
    description: "",
    isBestSeller: true,
  },
  {
    id: "love-report-ask-astrologer",
    badge: "BUDGET FRIENDLY",
    title: "Love Report + Ask The Astrologer",
    subtitle: "",
    priceOriginal: "₹1999",
    priceFinal: "₹1199",
    image: reportBook,
    features: [
        "Includes everything that’s part of the detailed Love Report — from energy analysis to compatibility.",
        "Ask One Personal question about your Love relationship or marriage life.",
        "Get a detailed written answer from an expert astrologer within 3 days.",
        "Perfect if you want love insights + a clear answer for relationship concern."
    ],
    description: "",
    isBestSeller: false,
  },
];

export type Plan = typeof pricingPlans[0] & {
  astroConsultationPrice?: number;
  expressDeliveryPrice?: number;
};